export default __webpack_public_path__ + "media/images/ui-bg_highlight-soft_75_ffe45c_1x100-8cbb1d31d59a19492034887a9727bc2d.png";